var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAlarmSnooze = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.23944L2.25 1M10.5 2.23944L8.75 1M9.9444 6.55556C9.9444 7.7343 9.4762 8.86476 8.6427 9.69825C7.8092 10.5317 6.67874 11 5.5 11C4.32126 11 3.1908 10.5317 2.3573 9.69825C1.52381 8.86476 1.05556 7.7343 1.05556 6.55556C1.05556 5.37682 1.52381 4.24635 2.3573 3.41286C3.1908 2.57936 4.32126 2.11111 5.5 2.11111C6.67874 2.11111 7.8092 2.57936 8.6427 3.41286C9.4762 4.24635 9.9444 5.37682 9.9444 6.55556Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80554 5.44434H6.19443L4.80554 7.66656H6.19443",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlarmSnooze, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alarm-snooze.f6b89262.svg";
export { ForwardRef as ReactComponent };